import { render, staticRenderFns } from "./ParallelCar.vue?vue&type=template&id=48403a7c"
import script from "./ParallelCar.vue?vue&type=script&lang=js"
export * from "./ParallelCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports